import { TableHeadersType } from "../tableHeadersType";

export const CLIENT_DIRECTORY_HEADERS: TableHeadersType[] = [
    {
        "label": "CLIENT NAME",
        "value": "company_name",
        "defaultChecked": true,
        "checked": true
    },
    // {
    //     "label": "CODE",
    //     "value": "client_code",
    //     "defaultChecked": true,
    //     "checked": true
    // },
    {
        "label": "CONTACT TYPE",
        "value": "contact_type",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "MANAGER",
        "value": "manager",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "BRANCH",
        "value": "branch_name",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "CLIENT CATEGORY",
        "value": "client_category",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "SCOPE OF WORK",
        "value": "scope_of_work",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "CLIENT FROM",
        "value": "client_from",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": 'ADDED/MODIFIED BY',
        "value": 'updated_at',
        "checked": true,
        "defaultChecked": true
      },
    {
        "label": "STATUS",
        "value": "status"
    },
   
]